export default __webpack_public_path__ + "static/media/bell_btn_active.1054bf0f.png";